import { CurrencyCodeType } from '@/types/currency';
import { FiatAccountType } from '@/types/fiatAccountType';

export interface BankData {
  readonly routingNumber: string;
  readonly name: string;
  readonly addressFull?: string;
  readonly street?: string;
  readonly zip?: string;
  readonly city?: string;
  readonly state?: string;
}

export interface BankInfoResponse {
  readonly status: string;
  readonly data: BankData;
}

export interface SwiftBankInfoResponse {
  readonly success: boolean;
  readonly data: {
    id: string;
    bank: {
      name: string;
    };
    name: string;
    address: string;
    postcode: string;
    cityName: string;
  };
}

export interface IbanBankInfoResponse {
  readonly success: boolean;
  readonly data: {
    id: string;
    accountNumber: string;
    nationalBankCode: string;
    nationalBranchCode: string;
    swift: SwiftBankInfoResponse['data'];
    country: {
      id: string;
      name: string;
    };
  };
}

export interface BankInfoRequest {
  readonly routingNumber: string;
  readonly paymentType: FiatAccountType;
}

export interface DetailedMultiCurrenciesBalancesRequest {
  readonly beneficiaryId: string | null;
  readonly currency: ReadonlyArray<CurrencyCodeType>;
}

export interface DetailedBalancesRequest {
  readonly beneficiaryId: string | null;
  readonly currency: CurrencyCodeType;
}

export interface DetailedBalance {
  readonly total: number;
  readonly available: number;
  readonly pending: number;
  readonly currencyCode: CurrencyCodeType;
}

export class DetailedBalance {
  public static zero(currency: CurrencyCodeType): DetailedBalance {
    return {
      total: 0,
      available: 0,
      pending: 0,
      currencyCode: currency,
    };
  }
}
